var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconbar-item",on:{"click":function($event){return _vm.showSidepanel()}}},[_c('I',{staticStyle:{"font-size":"2rem"},attrs:{"name":this.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }